import { useEffect, useMemo } from "react";
import { useQuery } from "react-query";
import { getAllPropertiesSummary } from "../../utils/api";
import { sortPropertiesByStatusPriority } from "@/utils/propertySorting";
import { getLogger } from "@/utils/logger";
import useAuthAwarePublicQueryGate from "@/components/hooks/useAuthAwarePublicQueryGate";

const log = getLogger("useProperties");


const useProperties = () => {
  const { authResolved } = useAuthAwarePublicQueryGate();
  const { data: rawData, isLoading, isError, refetch } = useQuery(
    "allProperties",
    getAllPropertiesSummary, // Using optimized endpoint with 60-70% smaller payload
    {
      enabled: authResolved,
      refetchOnWindowFocus: true,
    }
  );

  // Backend already enforces property status visibility per requester.
  const data = useMemo(() => {
    if (!rawData || !Array.isArray(rawData)) return rawData;
    return sortPropertiesByStatusPriority(rawData);
  }, [rawData]);

  useEffect(() => {
    log.info(
      `[useProperties:rawDataEffect] > [Request]: getAllPropertiesSummary > [Response]: rawDataCount=${
        Array.isArray(rawData) ? rawData.length : rawData ? "<non-array>" : "<none>"
      }`
    );
  }, [rawData]);

  useEffect(() => {
    log.info(
      `[useProperties:filteredDataEffect] > [Request]: filterProperties > [Response]: filteredDataCount=${
        Array.isArray(data) ? data.length : data ? "<non-array>" : "<none>"
      }`
    );
  }, [data]);

  return {
    data,
    isError,
    isLoading,
    refetch,
  };
};

export default useProperties;
